<script>
  /* global L */
  import { onMount } from 'svelte';

  export let value;
  export let lang = undefined;

  let mapElement;

  onMount(() => {
    const API_KEY = 'PG0Z8XYn_uhO4gczDEUo5YMcUySvcI4ekDVsg5UsJQY';
    const ZOOM = 10;

    const map = L.map(mapElement).setView([value.latitude, value.longitude], ZOOM);

    L.tileLayer(`https://api.mapy.cz/v1/maptiles/outdoor/256@2x/{z}/{x}/{y}?lang=${lang}&apikey=${API_KEY}`, {
      minZoom: 5,
      attribution: '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
    }).addTo(map);

    const LogoControl = L.Control.extend({
      options: {
        position: 'bottomleft',
      },

      onAdd: () => {
        const container = L.DomUtil.create('div');
        const link = L.DomUtil.create('a', '', container);

        link.setAttribute('href', 'http://mapy.cz/');
        link.setAttribute('target', '_blank');
        link.innerHTML = '<img src="https://api.mapy.cz/img/api/logo.svg"/>';

        L.DomEvent.disableClickPropagation(link);

        return container;
      },
    });

    new LogoControl().addTo(map);

    L.marker([value.latitude, value.longitude]).addTo(map);
  });
</script>

<div class='map'>
  <div class='map-element' bind:this={mapElement}/>

  <div class='map-label'>
    {Math.abs(value.latitude) + (value.latitude >= 0 ? 'N' : 'S')},
    {Math.abs(value.longitude) + (value.longitude >= 0 ? 'E' : 'W')}
  </div>
</div>

<style>
  .map {
    display: flex;
    flex-direction: column;
    gap: 5px;

    width: 100%;
    height: 100%;
  }

  .map-element {
    width: 100%;
    height: calc(100% - 20px);

    border-radius: 5px;

    background: var(--grey-1);
  }

  .map-label {
    height: 15px;

    color: var(--grey-7);

    font-size: 12px;
    font-style: italic;
  }

  :global(body.dark) .map-element {
    background: var(--grey-8);
  }

  :global(body.dark) .map-label {
    color: var(--grey-5);
  }

  :global(.leaflet-pane) {
    z-index: 0 !important;
  }

  :global(.leaflet-top) {
    z-index: 1 !important;
  }

  :global(.leaflet-bottom) {
    z-index: 1 !important;
  }
</style>
